export default {
    name: 'Nome',
    tel: 'Telefone',
    save: 'Salvar',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    delete: 'Excluir',
    complete: 'Concluir',
    loading: 'Carregando...',
    telEmpty: 'Preencha o telefone',
    nameEmpty: 'Preencha o nome',
    nameInvalid: 'Nome inválido',
    confirmDelete: 'Tem certeza que deseja excluir?',
    telInvalid: 'Número de telefone inválido',
    vanCalendar: {
        end: 'Fim',
        start: 'Início',
        title: 'Calendário',
        startEnd: 'Início/Fim',
        weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthTitle: function monthTitle(year, month) {
            return year + "/" + month;
        },
        rangePrompt: function rangePrompt(maxRange) {
            return "Escolha no máximo " + maxRange + " dias";
        }
    },
    vanCascader: {
        select: 'Selecionar'
    },
    vanContactCard: {
        addText: 'Adicionar contato'
    },
    vanContactList: {
        addText: 'Adicionar novo contato'
    },
    vanPagination: {
        prev: 'Anterior',
        next: 'Próximo'
    },
    vanPullRefresh: {
        pulling: 'Puxe para atualizar...',
        loosing: 'Solte para atualizar...'
    },
    vanSubmitBar: {
        label: 'Total: '
    },
    vanCoupon: {
        unlimited: 'Ilimitado',
        discount: function discount(_discount) {
            return _discount * 10 + "% de desconto";
        },
        condition: function condition(_condition) {
            return "Mínimo de " + _condition;
        }
    },
    vanCouponCell: {
        title: 'Cupom',
        tips: 'Sem cupons',
        count: function count(_count) {
            return "Você tem " + _count + " cupons";
        }
    },
    vanCouponList: {
        empty: 'Sem cupons',
        exchange: 'Trocar',
        close: 'Fechar',
        enable: 'Disponível',
        disabled: 'Indisponível',
        placeholder: 'Código do cupom'
    },
    vanAddressEdit: {
        area: 'Área',
        postal: 'CEP',
        areaEmpty: 'Selecione a área de entrega',
        addressEmpty: 'Endereço não pode estar vazio',
        postalEmpty: 'CEP inválido',
        defaultAddress: 'Definir como endereço padrão',
        telPlaceholder: 'Telefone',
        namePlaceholder: 'Nome',
        areaPlaceholder: 'Área'
    },
    vanAddressEditDetail: {
        label: 'Endereço',
        placeholder: 'Endereço'
    },
    vanAddressList: {
        add: 'Adicionar novo endereço'
    }
};